import { unFormatCurrency } from '@/common/utils/unFormatters'
import { MaintenanceDirectiveObjectiveData } from '@/features/maintenance/features/workflows/types/forwardings/directiveEntries/directiveEntry.type'
import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { UpdateExecutionEntryEstablishmentAcceptValidationSchema } from '../../../../../../schemas/updateExecutionEntryEstablishmentAccept.schema'
import ProposalGroupHeader from '../ProposalGroupHeader'
import PieceRow from './PieceRow'

interface ExecutionObjectivePiecesProps {
  executionObjective: MaintenanceDirectiveObjectiveData
  pieceStartIndex: number
}

const ExecutionObjectivePieces = ({ executionObjective, pieceStartIndex }: ExecutionObjectivePiecesProps) => {
  const { control } = useFormContext<UpdateExecutionEntryEstablishmentAcceptValidationSchema>()

  const formPieces = useWatch({ control, name: 'pieces' })

  const piecesCountDisplay = useMemo(() => {
    const count = executionObjective.execution_pieces?.length || 0

    if (count === 0) {
      return 'Nenhuma peça'
    }

    if (count === 1) {
      return '1 Peça'
    }

    return `${count} Peças`
  }, [executionObjective.execution_pieces?.length])

  const totalValueSum = useMemo(() => {
    return (
      executionObjective.execution_pieces?.reduce((prev, curr, index) => {
        const fieldIndex = pieceStartIndex + index
        const formPiece = formPieces?.[fieldIndex]
        const originalUnitPrice = Number(curr.unit_price) || 0
        const quantity = Number(curr.quantity) || 0

        const newUnitPriceNumber = formPiece?.new_unit_price ? unFormatCurrency(formPiece.new_unit_price) : null

        if (newUnitPriceNumber !== null && newUnitPriceNumber !== originalUnitPrice) {
          return prev + newUnitPriceNumber * quantity
        }

        return prev + (Number(curr.total_value) || 0)
      }, 0) || 0
    )
  }, [formPieces, executionObjective.execution_pieces, pieceStartIndex])

  return (
    <div className="flex flex-col gap-4">
      <ProposalGroupHeader title="Peças" countDisplay={piecesCountDisplay} totalValueSum={totalValueSum} />

      <div className="flex flex-col gap-3">
        {executionObjective.execution_pieces?.map((executionPiece, index) => {
          const fieldIndex = pieceStartIndex + index

          return <PieceRow key={executionPiece.id} executionPiece={executionPiece} fieldIndex={fieldIndex} />
        })}
      </div>
    </div>
  )
}

export default ExecutionObjectivePieces
